export default __webpack_public_path__ + "static/media/title_case3.c317c5a7.jpg";